(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["corner-goros-parts"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('corner-parts')) {
  class CornerParts extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.words = JSON.parse(this.querySelector('[data-text]').textContent);
      this.form = this.querySelector('.cp-form');
      this.qty = this.querySelector('[name="quantity"]');
      this.add = this.querySelector('[data-add]');
      this.notice = this.querySelector('[data-notice]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'ja', {style:'currency', currency:this.dataset.currency || 'JPY'});
      this.form.addEventListener('change', (e) => { if (e.target.name === 'id') { this.notice.hidden = true; this.update(true); } else if(e.target.name === 'quantity') this.update(); });
      this.qty.addEventListener('input', () => this.update());
      this.querySelector('[data-minus]').addEventListener('click', () => { this.qty.stepDown(); this.update(); });
      this.querySelector('[data-plus]').addEventListener('click', () => { this.qty.stepUp(); this.update(); });
      this.photos = [...this.querySelectorAll('[data-photo]')];
      this.photoCache = new Map();
      this.currentPhoto = this.photos.find(button => button.getAttribute('aria-pressed') === 'true') || this.photos[0];
      this.photos.forEach(button => {
        button.addEventListener('click', () => this.selectPhoto(button));
        button.addEventListener('pointerenter', () => this.loadPhoto(button, 'low'));
        button.addEventListener('focus', () => this.loadPhoto(button, 'low'));
      });
      this.dialog = this.querySelector('.cp-dialog');
      this.querySelector('[data-zoom]')?.addEventListener('click', () => this.openZoom());
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', e => { if(e.target === this.dialog) this.dialog.close(); });
      this.onGalleryReady = () => this.preloadNeighbors(this.currentPhoto);
      if(document.readyState === 'complete') this.onGalleryReady();
      else window.addEventListener('load', this.onGalleryReady, {once:true});
      this.inquiry = this.querySelector('.cp-inquiry');
      this.querySelectorAll('[data-inquiry-open]').forEach(link => link.addEventListener('click', e => {
        if(typeof this.inquiry.showModal !== 'function') return;
        e.preventDefault(); this.syncInquiry(); this.inquiry.showModal();
        this.inquiry.querySelector('h2').focus({preventScroll:true});
      }));
      this.querySelector('[data-inquiry-close]').addEventListener('click', () => this.inquiry.close());
      this.inquiry.addEventListener('click', e => { if(e.target === this.inquiry) this.inquiry.close(); });
      this.inquiry.querySelector('form').addEventListener('submit', () => this.syncInquiry());
      if(this.inquiry.querySelector('[data-contact-result]')) this.inquiry.showModal?.();
      this.form.addEventListener('submit', e => this.submit(e));
      this.querySelectorAll('[data-select-variant]').forEach(link => link.addEventListener('click', e => {
        const input = this.form.querySelector('input[name="id"][value="' + link.dataset.selectVariant + '"]');
        e.preventDefault(); if(input && !input.disabled && !this.busy) { input.checked = true; this.update(true); this.form.scrollIntoView({behavior:'auto',block:'start'}); input.focus({preventScroll:true}); }
      }));
      const previewId = new URL(location.href).searchParams.get('preview_theme_id');
      if(previewId) this.querySelectorAll('a[href]').forEach(link => { const target = new URL(link.href,location.href); if(target.origin === location.origin && target.pathname.includes('/products/')) { target.searchParams.set('preview_theme_id',previewId); link.href = target.href; } });
      this.onPopState = () => { const id = new URL(location.href).searchParams.get('variant'); const input = this.form.querySelector('input[name="id"][value="' + id + '"]'); if(input && !input.disabled) { input.checked = true; this.update(false); } };
      window.addEventListener('popstate', this.onPopState);
      this.update();
      this.observer = new IntersectionObserver(entries => { const rect = entries[0].boundingClientRect; this.querySelector('[data-sticky]').hidden = rect.bottom > 0; }, {threshold:0});
      this.observer.observe(this.form);
    }
    disconnectedCallback() {
      this.observer?.disconnect(); window.removeEventListener('popstate',this.onPopState);
      window.removeEventListener('load',this.onGalleryReady); clearTimeout(this.preloadTimer);
      this.photoRequest = (this.photoRequest || 0) + 1;
    }
    photoUrl(button) {
      const box = this.querySelector('.cp-photo');
      const pixels = (box.clientWidth || Math.min(window.innerWidth, 720)) * Math.min(window.devicePixelRatio || 1, 2);
      const cap = window.innerWidth < 900 ? 1000 : 1400;
      const width = Math.min(cap, [540,750,1000,1400].find(value => value >= pixels) || 1400);
      const url = new URL(button.dataset.photo, location.href); url.searchParams.set('width',width);
      return url.href;
    }
    loadPhoto(button, priority = 'high') {
      const url = this.photoUrl(button);
      let cached = this.photoCache.get(url);
      if(cached) { if(priority === 'high') cached.image.fetchPriority = 'high'; return cached; }
      const image = new Image(); image.decoding = 'async'; image.fetchPriority = priority;
      cached = {image, url, ready:false};
      cached.promise = new Promise(resolve => {
        image.onload = async () => {
          try { await image.decode?.(); } catch (_) { /* A loaded image can still be displayed if decoding is unavailable. */ }
          cached.ready = true; resolve(true);
        };
        image.onerror = () => { this.photoCache.delete(url); resolve(false); };
      });
      this.photoCache.set(url,cached); image.src = url;
      return cached;
    }
    preloadNeighbors(button) {
      clearTimeout(this.preloadTimer);
      if(navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return;
      this.preloadTimer = setTimeout(() => {
        if(!this.isConnected) return;
        const i = this.photos.indexOf(button);
        [this.photos[i-1],this.photos[i+1]].filter(Boolean).forEach(next => this.loadPhoto(next,'low'));
      }, 120);
    }
    async selectPhoto(button) {
      const img = this.querySelector('.cp-hero');
      if(!img || !button) return;
      const request = this.photoRequest = (this.photoRequest || 0) + 1;
      const box = this.querySelector('.cp-photo');
      const error = this.querySelector('[data-photo-error]'); error.hidden = true;
      this.photos.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      const cached = this.loadPhoto(button);
      box.setAttribute('aria-busy',String(!cached.ready));
      const loaded = cached.ready || await cached.promise;
      if(request !== this.photoRequest || !this.isConnected) return;
      box.setAttribute('aria-busy','false');
      if(!loaded) {
        error.hidden = false;
        this.photos.forEach(item => item.setAttribute('aria-pressed',String(item === this.currentPhoto)));
        return;
      }
      img.removeAttribute('srcset'); img.src = cached.url;
      img.alt = button.dataset.alt || this.dataset.productTitle;
      this.currentPhoto = button;
      this.preloadNeighbors(button);
    }
    openZoom() {
      const source = this.querySelector('.cp-hero'); const image = this.dialog.querySelector('img');
      image.src = this.currentPhoto?.dataset.zoomPhoto || source.currentSrc || source.src;
      image.alt = source.alt;
      this.dialog.showModal();
    }
    syncInquiry() {
      if(!this.variant || !this.inquiry.querySelector('[data-inquiry-variant]')) return;
      const v = this.variant;
      this.inquiry.querySelector('[data-inquiry-choice]').textContent = v.title;
      this.inquiry.querySelector('[data-inquiry-sku]').textContent = v.sku || '—';
      this.inquiry.querySelector('[data-inquiry-variant]').value = v.title;
      this.inquiry.querySelector('[data-inquiry-sku-input]').value = v.sku || '';
      const productUrl = new URL(this.dataset.productUrl, location.origin);
      productUrl.searchParams.set('variant',v.id);
      this.inquiry.querySelector('[data-inquiry-url]').value = productUrl.href;
      const back = new URL(location.href); back.hash = this.inquiry.querySelector('form').id;
      back.searchParams.delete('contact_posted');
      const returnTo = this.inquiry.querySelector('[name="return_to"]');
      if(returnTo) returnTo.value = back.pathname + back.search + back.hash;
    }
    update(changed = false) {
      const id = this.form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]')?.value;
      this.variant = this.variants.find(item => String(item.id) === id) || this.variants[0];
      const v = this.variant;
      this.qty.min = v.min; this.qty.step = v.step;
      if(v.max !== null) this.qty.max = v.max; else this.qty.removeAttribute('max');
      if(changed) { this.qty.value = v.min; const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({},'',url); }
      const count = Number(this.qty.value);
      this.querySelectorAll('[data-choice]').forEach(el => el.textContent = v.title === 'Default Title' ? this.dataset.productTitle : v.title);
      this.querySelectorAll('[data-sku]').forEach(el => el.textContent = v.sku || '—');
      this.querySelector('[data-unit-price]').textContent = v.priceText;
      const compare = this.querySelector('[data-compare]'); compare.hidden = !(v.compare > v.price); compare.textContent = v.compareText;
      this.querySelectorAll('[data-total]').forEach(el => el.textContent = this.money.format(v.price * (Number.isFinite(count) ? count : 0) / 100));
      const possible = v.available && (v.max === null || v.max >= v.min);
      const unavailableText = v.available ? this.words.limitReached : this.words.soldOut;
      this.querySelector('[data-stock]').textContent = possible ? this.words.available : unavailableText;
      this.querySelectorAll('[data-select-variant]').forEach(link => link.setAttribute('aria-current',String(link.dataset.selectVariant === String(v.id))));
      this.add.disabled = this.busy || !possible;
      this.add.textContent = this.busy ? this.words.adding : possible ? this.words.add + '  →' : unavailableText;
      this.querySelector('[data-minus]').disabled = this.busy || count <= v.min;
      this.querySelector('[data-plus]').disabled = this.busy || (v.max !== null && count + v.step > v.max);
      const limit = this.querySelector('[data-limit]'); limit.hidden = v.max === null;
      limit.textContent = this.words.limit.replace('{max}', String(v.max));
      if(changed && v.imageId) { const thumb = this.querySelector('[data-image-id="' + v.imageId + '"]'); if(thumb) this.selectPhoto(thumb); }
    }
    async submit(event) {
      event.preventDefault();
      if(this.busy) return;
      if(!this.form.reportValidity()) return;
      const v = this.variant, quantity = Number(this.qty.value);
      if(!Number.isInteger(quantity) || quantity < v.min || (quantity - v.min) % v.step !== 0 || (v.max !== null && quantity > v.max)) { this.showMessage(this.words.invalid,true); return; }
      const settings = window.MinimogSettings || {};
      const cartDrawer = settings.enable_cart_drawer === false ? null : document.querySelector('m-cart-drawer');
      const drawer = settings.use_ajax_atc !== false && typeof cartDrawer?.renderContents === 'function' ? cartDrawer : null;
      const payload = {items:[{id:v.id,quantity}]};
      if(drawer) {
        payload.sections = drawer.getSectionsToRender().map(section => section.id);
        payload.sections_url = location.pathname + location.search;
      }
      this.busy = true; this.update(); this.notice.hidden = true;
      const cartLink = this.querySelector('[data-cart-link]'); cartLink.hidden = true;
      const buttons = [...this.form.querySelectorAll('input[name="id"]')];
      buttons.forEach(input => input.disabled = true); this.qty.readOnly = true;
      let confirmed = false;
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const data = await response.json();
        if(!response.ok || Number(data.status) >= 400) {
          this.showMessage(typeof data.description === 'string' ? data.description : this.words.error,true);
          return;
        }
        confirmed = true;
        if(v.max !== null) v.max = Math.max(0,v.max - quantity);
        this.qty.value = v.min;
        this.showMessage(this.words.added.replace('{variant}',v.title === 'Default Title' ? this.dataset.productTitle : v.title).replace('{quantity}',String(quantity)));
        cartLink.hidden = false;
        if(drawer) {
          drawer.renderContents(data);
          drawer.setActiveElement?.(this.add);
          this.notice.hidden = true; cartLink.hidden = true;
        }
        // Keep the native response identity so cart listeners do not render or fetch twice.
        if(window.MinimogEvents && window.MinimogTheme) {
          try { window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, data); } catch (_) { /* The confirmed cart remains usable if an app listener fails. */ }
        }
        if(!drawer) this.openCartPage();
      } catch(error) {
        // A display failure after a confirmed add must never invite a duplicate submission.
        if(!confirmed) this.showMessage(this.words.unknown,true);
        this.notice.hidden = false; cartLink.hidden = false;
      }
      finally { this.busy = false; this.qty.readOnly = false; buttons.forEach(input => { const variant = this.variants.find(item => String(item.id) === input.value); input.disabled = !variant.available; }); this.update(); }
    }
    openCartPage() { location.assign(window.MinimogSettings?.routes?.cart || this.querySelector('[data-cart-link]').href); }
    showMessage(message,isError=false) { this.notice.textContent = message; this.notice.dataset.error = String(isError); this.notice.hidden = false; }
  }
  customElements.define('corner-parts',CornerParts);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corner-home-leather"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('corner-home-leather')) {
  customElements.define('corner-home-leather', class extends HTMLElement {
    connectedCallback() {
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (!preview) return;
      this.querySelectorAll('[data-leather-product]').forEach(link => {
        const target = new URL(link.href, location.href);
        target.searchParams.set('preview_theme_id', preview);
        link.href = target.href;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('corner-related-products')) {
  customElements.define('corner-related-products', class extends HTMLElement {
    connectedCallback() { if (!this.loaded) this.load(); }
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.controller = new AbortController();
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('corner-related-products');
        if (content && this.isConnected) {
          this.innerHTML = content.innerHTML;
          this.loaded = true;
        }
      } catch (error) {
        this.loaded = false;
      } finally {
        this.loading = false;
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
